export default __webpack_public_path__ + "static/media/Crop 2.0b6a8d48.svg";